"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_memoize_1 = tslib_1.__importDefault(require("lodash.memoize")); // tslint:disable-line:match-default-export-name
var shallowequal_1 = tslib_1.__importDefault(require("shallowequal"));
var cache_key_resolver_1 = tslib_1.__importDefault(require("./cache-key-resolver"));
function memoize(fn, options) {
    var _a = tslib_1.__assign({ maxSize: 0, isEqual: shallowequal_1.default }, options), maxSize = _a.maxSize, isEqual = _a.isEqual;
    var cache = new Map();
    var resolver = new cache_key_resolver_1.default({
        isEqual: isEqual,
        maxSize: maxSize,
        onExpire: function (key) { return cache.delete(key); },
    });
    var memoized = lodash_memoize_1.default(fn, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return resolver.getKey.apply(resolver, args);
    });
    memoized.cache = cache;
    return memoized;
}
exports.default = memoize;
function memoizeOne(fn, options) {
    return memoize(fn, tslib_1.__assign({}, options, { maxSize: 1 }));
}
exports.memoizeOne = memoizeOne;
//# sourceMappingURL=memoize.js.map